import O1HD from "../../../engines/gameEngine";
import utilsModel from "../../../engines/libs/utilsModel";
import utilsView from "../../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../../engines/modules/uiModule";
import { PLATFORM_CODE } from "../../../engines/services/ossService";
import { CsvFileKind } from "../../../modes/define/CsvFileKind";
import { MessageEventKind } from "../../../modes/define/MessageEventKind";
import { TaskKind } from "../../../modes/define/TaskKind";
import NormalGameManager from "../../../modes/normalMode/manager/NormalGameManager";
import healBreiberiTagNode from "./healBreiberiTagNode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class healBeriberiGame extends cc.Component {

    @property({type:cc.Node,tooltip:"伤口节点"})
    woundNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"纱布节点"})
    gauzeNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"泥土格子节点"})
    sludgeGridNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"灰指甲节点"})
    grayFingerNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"普通指甲节点"})
    normalFingerNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"指甲油格子节点"})
    nailPolishGridNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"指甲油节点"})
    nailPolishNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"脚气格子节点"})
    beriberiGridNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"脚气移动节点"})
    plasterTouchNode:cc.Node = null;

    @property({type:cc.Mask,tooltip:"药膏mask节点"})
    unguentMask:cc.Mask = null;

    @property({type:cc.Node,tooltip:"脚气节点"})
    beriberiNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"道具layout"})
    propLayout:cc.Node = null;

    @property({type:cc.Mask,tooltip:"污泥mask节点"})
    sludgeMask:cc.Mask = null;

    @property({type:cc.Node,tooltip:"脚的碰撞"})
    footTrigger:cc.Node = null;

    @property({type:cc.Node,tooltip:"失败节点"})
    loseNode:cc.Node = null;

    curStep:number = 0;

    errorCount:number = 0;

    canErrorCount:number = 2;

    soundId:number = null;

    start(){
        this.propAddEvent();
    }

    propAddEvent(){
        this.propLayout.children.forEach((n:cc.Node)=>{
            this.addOneNodeEvent(n);
        });
    }

    addOneNodeEvent(n:cc.Node){
        n.on('touchstart',this.onTouchPropStart,this);
        n.on('touchmove',this.onTouchPropMove,this);
        n.on('touchend',this.onTouchPropEnd,this);
        n.on('touchcancel',this.onTouchPropEnd,this);
    }

    removeOneNodeEvent(n:cc.Node){
        n.off('touchstart',this.onTouchPropStart,this);
        n.off('touchmove',this.onTouchPropMove,this);
        n.off('touchend',this.onTouchPropEnd,this);
        n.off('touchcancel',this.onTouchPropEnd,this);
    }

    curPropInitPos:cc.Vec2 = null;

    onTouchPropStart(e:cc.Event.EventTouch){
        let node:cc.Node = e.target;
        this.curPropInitPos = node.getPosition().clone();
        let spf : cc.Node = node.getChildByName("spf");
        spf.active = false;
        let spf2 :cc.Node = node.getChildByName("spf2");
        spf2.active = true;
        node.zIndex = 1;
        let nTag:number = node.getComponent(healBreiberiTagNode).tag;
        switch(nTag){
            case 0:{
                O1HD.getManagers().soundMgr.playSound("healBeriberi_jiujingxi",null,null,true).then((id)=>{
                    this.soundId = id;
                });
                break;
            }
            case 4:{
                O1HD.getManagers().soundMgr.playSound("healBeriberi_jiaoqiling",null,null,true).then((id)=>{
                    this.soundId = id;
                });
                break;
            }
        }
    }

    onTouchPropMove(e:cc.Event.EventTouch){
        let node:cc.Node = e.target;
        let nTag:number = node.getComponent(healBreiberiTagNode).tag;
        switch(nTag){
            case  0:{
                if(this.curStep != nTag && this.footTrigger.getBoundingBoxToWorld().contains(node.convertToWorldSpaceAR(cc.v2()))){
                    this.addErrorCount(node);
                    return;
                }else if(this.curStep == nTag){
                    this.wineCheck(node);
                }
                break;
            }
            case 1:{
                if(this.curStep != nTag && this.footTrigger.getBoundingBoxToWorld().contains(node.convertToWorldSpaceAR(cc.v2()))){
                    this.addErrorCount(node);
                    return;
                }else if(this.curStep == nTag){
                    this.breibreiCheck(node);
                }
                break;
            }
            case 2:{
                if(this.curStep != nTag && this.footTrigger.getBoundingBoxToWorld().contains(node.convertToWorldSpaceAR(cc.v2()))){
                    this.addErrorCount(node);
                    return;
                }else if(this.curStep == nTag){ 
                    this.scissorsCheck(node);
                }
                break;
            }
            case 3:{
                if(this.curStep != nTag && this.footTrigger.getBoundingBoxToWorld().contains(node.convertToWorldSpaceAR(cc.v2()))){
                    this.addErrorCount(node);
                    return;
                }
                break;
            }
            case 4:{
                if(this.curStep != nTag && this.footTrigger.getBoundingBoxToWorld().contains(node.convertToWorldSpaceAR(cc.v2()))){
                    this.addErrorCount(node);
                    return;
                }else if(this.curStep == nTag){
                    this.nailPolishCheck(node);
                }
                break;
            }
        }
        let delta:cc.Vec2 = e.getDelta();
        node.x += delta.x;
        node.y += delta.y;
    }

    onTouchPropEnd(e:cc.Event.EventTouch){
        if(this.soundId != null){
            O1HD.getManagers().soundMgr.stopSound(this.soundId);
            this.soundId = null;
        }
        let node:cc.Node = e.target;
        let nTag:number = node.getComponent(healBreiberiTagNode).tag;
        switch(nTag){
            case 0:{
                if(this.wineCheckAry.length >= this.sludgeGridNode.childrenCount && this.curStep == nTag){
                    // 该步骤完成
                    this.curStep = 1;
                    cc.tween(this.sludgeMask.node).to(1,{opacity:0}).call(()=>{
                        this.beriberiNode.active = true;
                        // this.beriberiNode.scale = 0;
                        this.beriberiNode.opacity = 0;
                        cc.tween(this.beriberiNode).to(1,{opacity:255}).start();
                    }).start();
                }
                break;
            }
            case 1:{
                if(this.breibreiCheckAry.length >= this.beriberiGridNode.childrenCount && this.curStep == nTag){
                    this.curStep = 2;
                    // this.breibreiGridAddEvent();
                    cc.tween(this.unguentMask.node).to(0.2,{opacity:0}).call(()=>{
                        cc.tween(this.normalFingerNode).to(0.5,{opacity:0}).start();
                        cc.tween(this.beriberiNode).to(0.5,{opacity:0}).start();
                    }).start();
                }
                break;
            }
            case 2:{
                if(this.scissorsCheckAry.length >= this.grayFingerNode.childrenCount && this.curStep == nTag){
                    this.curStep = 3;
                }
                break;
            }
            case 3:{    
                if(this.woundNode.getBoundingBoxToWorld().contains(node.convertToWorldSpaceAR(cc.v2())) && this.curStep == nTag){
                    let pos:cc.Vec2 = this.woundNode.convertToNodeSpaceAR(node.convertToWorldSpaceAR(cc.v2()));
                    let cNode:cc.Node = cc.instantiate(node);
                    this.woundNode.addChild(cNode);
                    cNode.setPosition(pos);
                    this.curStep = 4;
                    cc.tween(cNode).to(0.5,{opacity:0}).delay(0.2).call(()=>{
                        this.gauzeNode.active = true;
                        this.gauzeNode.opacity = 0;
                        cc.tween(this.gauzeNode).to(0.5,{opacity:255}).call(()=>{
                        }).delay(0.1).call(()=>{
                            cNode.destroy();
                        }).start();
                    }).start();
                }
                break;
            }
            case 4:{
                if(this.nailPolishCheckAry.length >= this.nailPolishGridNode.childrenCount && this.curStep == nTag){
                    this.curStep = 1000;
                    // 可以胜利了
                    // this.nailPolishNode.children.forEach((n:cc.Node)=>{
                    //     cc.tween(n).to(0.2,{width:100,height:100}).start();
                    // });
                    this.scheduleOnce(()=>{
                        this.win();
                    },2);
                }
                break;
            }
        }
        node.setPosition(this.curPropInitPos);
        let spf : cc.Node = node.getChildByName("spf");
        spf.active = true;
        let spf2 :cc.Node = node.getChildByName("spf2");
        spf2.active = false;
        node.zIndex = 0;
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.back();
    }

    breibreiCheckAry:string[] = [];

    breibreiCheck(node:cc.Node){        
        let tNode:cc.Node = node.getChildByName("trigger");
        let nTag:number = node.getComponent(healBreiberiTagNode).tag;
        let pos :cc.Vec2 = this.unguentMask.node.convertToNodeSpaceAR(tNode.convertToWorldSpaceAR(cc.v2()));
        // @ts-ignore
        this.unguentMask._graphics.fillColor = cc.Color.WHITE;
        // @ts-ignore
        this.unguentMask._graphics.strokeColor = cc.Color.WHITE;
        // @ts-ignore
        this.unguentMask._graphics.circle (pos.x,pos.y, 40 )
        // @ts-ignore
        this.unguentMask._graphics.fill();
        // @ts-ignore
        this.unguentMask._graphics.stroke();
        this.beriberiGridNode.children.forEach((n:cc.Node)=>{
            if(n.getBoundingBoxToWorld().contains(tNode.convertToWorldSpaceAR(cc.v2())) && !this.breibreiCheckAry.includes(n.uuid) && this.curStep == nTag){
                this.breibreiCheckAry.push(n.uuid);
            }
        });
    }

    // breibreiGridAddEvent(){
    //     this.plasterTouchNode.on('touchmove',this.onTouchMoveBreibrei,this);
    // }

    // breibreiGridRemoveEvent(){
    //     this.plasterTouchNode.off('touchmove',this.onTouchMoveBreibrei,this);
    // }

    // onTouchMoveBreibrei(e:cc.Event.EventTouch){
    //     let startPos:cc.Vec2 = e.getStartLocation();
    //     let curPos:cc.Vec2 = e.getLocation();
    //     if(startPos.sub(curPos).mag() > 30 && this.curStep == 5){
    //         this.curStep = 4;
    //         this.breibreiGridRemoveEvent();
    //         cc.tween(this.unguentMask.node).to(0.2,{opacity:0}).call(()=>{
    //             cc.tween(this.normalFingerNode).to(0.5,{opacity:0}).start();
    //             cc.tween(this.beriberiNode).to(0.5,{opacity:0}).start();
    //         }).start();
    //     }
    // }

    scissorsCheckAry:string[] = [];

    scissorsCheck(node:cc.Node){
        let tNode:cc.Node = node.getChildByName("trigger");
        let nTag:number = node.getComponent(healBreiberiTagNode).tag;
        this.grayFingerNode.children.forEach((n:cc.Node)=>{
            if(n.getBoundingBoxToWorld().contains(tNode.convertToWorldSpaceAR(cc.v2())) && !this.scissorsCheckAry.includes(n.uuid) && this.curStep == nTag){
                this.scissorsCheckAry.push(n.uuid);
                this.ScissorsAni(node);
                O1HD.getManagers().soundMgr.playSound("healBeriberi_jiandao");
                cc.tween(n).to(0.2,{opacity:0}).start();
            }
        });

    }

    wineCheckAry:string[] = [];

    wineCheck(node:cc.Node){
        let tNode:cc.Node = node.getChildByName("trigger");
        let nTag:number = node.getComponent(healBreiberiTagNode).tag;
        let pos :cc.Vec2 = this.sludgeMask.node.convertToNodeSpaceAR(tNode.convertToWorldSpaceAR(cc.v2()));
        // @ts-ignore
        this.sludgeMask._graphics.fillColor = cc.Color.WHITE;
        // @ts-ignore
        this.sludgeMask._graphics.strokeColor = cc.Color.WHITE;
        // @ts-ignore
        this.sludgeMask._graphics.circle (pos.x,pos.y, 40 )
        // @ts-ignore
        this.sludgeMask._graphics.fill();
        // @ts-ignore
        this.sludgeMask._graphics.stroke();

        this.sludgeGridNode.children.forEach((n:cc.Node)=>{
            if(n.getBoundingBoxToWorld().contains(tNode.convertToWorldSpaceAR(cc.v2())) && !this.wineCheckAry.includes(n.uuid) && this.curStep == nTag){
                this.wineCheckAry.push(n.uuid);
            }
        });
    }

    ScissorsAni(node:cc.Node){
        let spf2:cc.Node = node.getChildByName("spf2");
        let one:cc.Node = spf2.getChildByName("one");
        let two:cc.Node = spf2.getChildByName("two");
        cc.tween(one).to(0.1,{angle:-3}).delay(0.1).to(0.1,{angle:0}).start();
        cc.tween(two).to(0.1,{angle:3}).delay(0.1).to(0.1,{angle:0}).start();
    }

    nailPolishCheckAry:string[] = [];

    nailPolishCheck(node:cc.Node){
        let tNode:cc.Node = node.getChildByName("trigger");
        this.nailPolishNode.children.forEach((n:cc.Node)=>{
            let mask = n.getComponent(cc.Mask);
            let pos :cc.Vec2 = n.convertToNodeSpaceAR(tNode.convertToWorldSpaceAR(cc.v2()));
            // @ts-ignore
            mask._graphics.fillColor = cc.Color.WHITE;
            // @ts-ignore
            mask._graphics.strokeColor = cc.Color.WHITE;
            // @ts-ignore
            mask._graphics.circle (pos.x,pos.y, 40 )
            // @ts-ignore
            mask._graphics.fill();
            // @ts-ignore
            mask._graphics.stroke();
        });
        this.nailPolishGridNode.children.forEach((n:cc.Node)=>{
            if(n.getBoundingBoxToWorld().contains(tNode.convertToWorldSpaceAR(cc.v2())) && this.curStep == 4 && !this.nailPolishCheckAry.includes(n.uuid)){
                this.nailPolishCheckAry.push(n.uuid);
                O1HD.getManagers().soundMgr.playSound("healBeriberi_shuazi");
            }
        });
    }

    addErrorCount(node:cc.Node){
        O1HD.getManagers().soundMgr.playSound("healBeriberi_error");
        this.removeOneNodeEvent(node);
        node.setPosition(this.curPropInitPos);
        let spf : cc.Node = node.getChildByName("spf");
        spf.active = true;
        let spf2 :cc.Node = node.getChildByName("spf2");
        spf2.active = false;
        this.errorCount ++;
        if(this.errorCount >= this.canErrorCount){
            this.lose();
        }
        this.addOneNodeEvent(node);
    }

    win(){

        let bExit = NormalGameManager._instance.getGameData().saveCupidFlag;
        if(bExit && O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5){
            this.scheduleOnce(()=> {
                this.back();
            }, 2);
            return;
        }
        NormalGameManager._instance.taskDataManage.addNewTask(TaskKind.TaskId.TASK_3);
        NormalGameManager._instance.taskDataManage.addNewFinishTask(TaskKind.TaskId.TASK_2);
        // 打开事件
        this.openMainEvent("6");
    }

    openMainEvent(id: string) {
        let data = {
            id: id
            , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
            , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
            , onComplete: ()=> {
                
            }
            , exitLayer: ()=> {
                this.back();

                let day = NormalGameManager._instance.getCurrentDay();
                NormalGameManager._instance.setGameData({saveCupidFlag:true, finishCupidLv1Time: day});


                O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);
            }
        }
        utilsView.openEventLayer(
            null
            , data
            , UI_Z_INDEX.DIALOG
        );
    }

    needSubMoney:number = 0;

    lose(){
        this.loseNode.active = true;
        this.needSubMoney = O1HD.getServices().userSrv.getCoins() * 0.3;
    }

    back(){
        this.node.destroy();
    }

    onBtnOut(){
        O1HD.getServices().userSrv.setCoins(-this.needSubMoney,true);
        this.node.destroy();
    }

    onBtnRecoverLosses(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.back();
        },()=>{

        },null,"拯救丘比特观看广告挽回损失")
    }

    hintFlag:boolean = false;

    @property({type:cc.Node,tooltip:"提示节点"})
    hintNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"提示视频图标"})
    hintVideo:cc.Node = null;

    onBtnHint(){
        if(this.hintFlag){
            this.hintNode.active = true;
        }else{
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.hintFlag = true;
                this.hintVideo.active = false;
                this.hintNode.active = true;
            },()=>{},null,"拯救丘比特看广告看提示");
        }
    }

    onBtnCloseHint(){
        this.hintNode.active = false;
    }

}
